import { createContext, useContext } from 'react';

import type { TFilterSection } from '@stories/@types/custom';
import type { THitListViewProps } from '@stories/organisms/HitListView';
import type productListDefaultSettings from '@utils/data/ProductListDefaultSettings';
import type { reducerFunctions } from '@utils/productList/types';
import type { ActiveFiltersAndSorting } from '@utils/productList/useProductList';

export type productsAndAvailableFilters = {
  filterList: TFilterSection[];
  hits: Array<THitListViewProps>;
  total: number;
};

export const defaultFetchedState: productsAndAvailableFilters = {
  filterList: [],
  hits: [],
  total: 0
};

export type activeFilters = {
  [key: string]: string[];
};

export const ProductListContext = createContext<
  | {
      activeFiltersAndSorting: ActiveFiltersAndSorting;
      currentCategoryId?: number;
      defaultSettings: typeof productListDefaultSettings;
      reducerFunctions: reducerFunctions;
      productsAndAvailableFilters: productsAndAvailableFilters;
      scrollContainerRefIntoView?: () => void;
    }
  | undefined
>(undefined);

export const useProductListContext = () => {
  const context = useContext(ProductListContext);
  if (!context) {
    throw new Error('useProductListContext must be used within a ProductListContext');
  }
  return context;
};
